<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData" :add="authList.includes('role:add')" @add="addRole">
    </Filter>
    <Table ref="tableId" :tableData="tableDataList" :total="total" @update="updatePage" tooltip-effect="light">
      <el-table-column prop="createTime" :label="$t('activity.list.createTime')" />
      <el-table-column prop="name" :label="$t('system.role.role')" />
      <el-table-column prop="comment" :label="$t('system.role.roleDescription')" />
      <!-- <el-table-column prop="menus" label="菜单" >
        <template #default="{row}">{{ JSON.stringify(row.menus) }}</template>
      </el-table-column> -->
      <el-table-column :label="$t('activity.list.operation')"  width="100" fixed="right">
        <template #default="{row}">
          <el-button v-show="authList.includes('role:setMenu')" type="text" size="mini" @click="editMenu(row)">{{$t('system.role.editMenu')}}</el-button>
          <el-button type="text" size="mini" @click="editRole(row)">{{$t('activity.list.edit')}}</el-button>
          <!-- <el-button type="text" style="color: #f56c6c;" size="mini" @click="deleteRole">删除角色</el-button> -->
        </template>
      </el-table-column>
    </Table>
    <el-dialog :title="$t('system.role.editMenu')" top="5vh" v-model="dialogFormVisible" destroy-on-close :modal="true" :append-to-body="true">
      <el-tree ref="menuTree" :data="treeData" node-key="perms" show-checkbox />
      <template #footer>
        <el-button type="primary" size="small" @click="setRoleMenu">{{$t('activity.list.confirm')}}</el-button>
      </template>
    </el-dialog>
    <el-dialog :title="dialogTitle" v-model="dialogRoleVisible" destroy-on-close :modal="true" :append-to-body="true">
      <el-form ref="roleFormRef" class="dialog-form" :model="roleForm" :rules="roleFormRules" label-width="100px">
        <el-form-item :label="$t('system.role.roleName')" prop="name">
          <el-input :placeholder="$t('system.role.enterRoleName')" v-model="roleForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('system.role.roleDescription')" prop="comment">
          <el-input type="textarea" v-model="roleForm.comment" clearable :placeholder="$t('system.role.roleDescription')"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" size="mini" @click="onRoleSubmit">{{$t('activity.list.confirm')}}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, toRefs, nextTick } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";

import Table from "@/components/table/index";
import Filter from "@/components/table/filter";

import { common } from "@/common/mixin";
import { request } from "@/utils/request";
import { menus } from "@/router";
import { useI18n } from 'vue-i18n'
export default {
  components: {
    Table,
    Filter,
  },
  mixins: [common],
  setup() {
    const { t } = useI18n()
    const state = reactive({
      roleFormRef: null,
      params: [{
        key: "roleName",
        value: "",
        label: t('system.role.role')
      }],
      query: {},
      page: 1,
      size: 10,
      total: 0,
      tableDataList: [],
      dialogFormVisible: false,
      dialogRoleVisible: false,
      menuTree: null,
      treeData: menus, // 树
      roleName: '', // 
      roleId: null, // 编辑菜单
      authList: JSON.parse(window.localStorage.getItem('authList')),
      roleForm: {
        name: '',
        comment: '',
      },
      roleFormRules: {
        name: {
          required: true,
          message: t('system.role.enterRoleName'),
          trigger: 'blur'
        }
      },
      dialogTitle: ''
    })
    // watch(() => state.query,
    //   (cur, pre) => {
    //     console.log("新值:", cur, "老值:", pre);
    //     if (state.query.tag) {
    //       state.query[state.query.tag] = true
    //     }
    //   },
    //   { immediate: true, deep: true }
    // )
    const setupInit = () => {
      try {
        console.log('menus', menus)
        getData()
      } catch (error) {
         console.error(error)
      }
    }
    const getData = async () => {
      try {
        const res = await request("getRoleList", {
          ...state.query,
          page: state.page,
          size: state.size,
        })
        state.tableDataList = res.records
        state.total = res.total
      } catch (error) {
        console.error(error)
      }
    }
    const searchData = async (data) => {
      console.log('searchData', data)
      state.query = data;
      getData()
    }
    const updatePage = (page, size) => {
      state.page = page || 1
      state.size = size || 10
      getData()
    }
    const onRoleSubmit = async () => {
      state.roleFormRef && await state.roleFormRef.validate()
      try {
        await request("addRole", state.roleForm)
        getData()
        state.dialogRoleVisible = false
        ElMessage({
          showClose: true,
          type: "success",
          message: state.roleForm.id ? t('system.user.roleModifySuccess') : t('system.role.roleAddSuccess')
        })
      } catch (error) {
        console.error(error)
      }
    }
    const addRole = () => {
      state.dialogRoleVisible = true
      state.dialogTitle = t('system.role.addRole')
      for (let key of Object.keys(state.roleForm)) {
        state.roleForm[key] = ""
      }
      // ElMessageBox.prompt(t('system.role.enterRoleName'), {
      //   confirmButtonText: t('activity.list.confirm1'),
      //   cancelButtonText: t('activity.list.cancel'),
      //   inputValue: state.roleName,
      //   inputType: 'text',
      //   inputPattern: /^[^\s]+$/,
      //   inputErrorMessage: t('activity.packetjoin.invalidInput')
      // }).then(({ value }) => {
      //   console.log('prompt', value)
      //   value && addRole(value)
      // }).catch(() => {
      // })
    }
    const editRole = async (row) => {
      try {
        for (let key of Object.keys(state.roleForm)) {
          if (row[key]) {
            state.roleForm[key] = row[key];
          } else {
            state.roleForm[key] = "";
          }
        }
        state.dialogTitle = t('system.user.modifyRole')
        state.roleForm.id = row.id
        state.dialogRoleVisible = true
      } catch (error) {
        console.error(error);
      }
    }
    const editMenu = async (row) => {
      row.menus = await request('getRoleMenuList', { roleId: row.id})
      state.dialogFormVisible = true
      const checkedKeys = []
      if (row.menus) {
        row.menus.forEach((menu) => {
          menu.children && menu.children.forEach((sub) => {
            if(sub.children && sub.children.length == 0){
              checkedKeys.push(sub.perms)
            }
            sub.children && sub.children.forEach((subSub) => {
              checkedKeys.push(subSub.perms)
            })
          })
        })
      }
      console.log('selectMenus', checkedKeys)
      nextTick(()=>{
        state.menuTree.setCheckedKeys(checkedKeys)
      })
      state.roleId = row.id
    }
    const setRoleMenu = async () => {
      try {
        const checkedKeys = state.menuTree.getCheckedKeys() || []
        console.log('selectMenus', checkedKeys)
        const checkedMenus = []
        state.treeData.forEach(menu => {
          if (checkedKeys.includes(menu.perms)) {
            // 一级菜单被选中
            checkedMenus.push(menu)
          } else {
            // 检查二级菜单
            let children = []
            menu.children.forEach((sub)=>{
              if (checkedKeys.includes(sub.perms)) {
                // 二级菜单被选中
                children.push(sub)
              }else{
                // 检查三级菜单
                let grandchildren = []
                if (sub.children && sub.children.length > 0) {
                  sub.children.forEach((subSub) => {
                    if (checkedKeys.includes(subSub.perms)) {
                      // 三级菜单被选中，需要包含父级（二级菜单）
                      grandchildren.push(subSub)
                    }
                  })
                }

                // 如果三级菜单有被选中的
                if (grandchildren.length > 0) {
                  // 创建包含选中三级菜单的二级菜单结构
                  children.push({
                    perms: sub.perms,
                    path: sub.path,
                    label: sub.label,
                    children: grandchildren
                  })
                }
              }
            })
            if (children.length>0) checkedMenus.push({ path: menu.path, label: menu.label, children: children})
          }
        })
        console.log('checkedMenus', checkedMenus, state.treeData)
        await request("setRoleMenu", {
          roleId: state.roleId,
          menu: checkedMenus
        })
        state.dialogFormVisible = false
        // getData()
      } catch (error) {
        console.error(error)
      }
    }

    setupInit()
    return {
      ...toRefs(state),
      getData,
      searchData,
      updatePage,
      onRoleSubmit,
      editMenu,
      setRoleMenu,
      addRole,
      editRole
    };
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>
